<template>
    <div>
        <div v-show="section === 'offers'" class="offers-page p-6 mx-auto md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4">
            <offers
                :custom-offer="customOffer"
                :billing-profile="billingProfile"
                @continue="preview"
            />
        </div>

        <payment-authorization
            v-if="section === 'payment-authorization'"
            :account-id="account.id"
            :consumer-portal-data="data"
            :transactions="paymentAuthorizationTransactions"
            :template="paymentAuthorizationAgreementTemplate"
            @accepted="accept"
            @canceled="previewDeclined"
        />

        <offer-summary v-else-if="section === 'summary'"
            :consumer-portal-data="data"
            :transactions="transactions"
            :settings="$parent.settings"
            :account="account"
            :details="{
                account_id: account.id
            }"
            :electronic-consent-template="electronicConsentTemplate"
            :electronic-consent-declined-template="electronicConsentDeclinedTemplate"
        />
    </div>
</template>

<script>
    import Offers from './CustomOffers/Offers.vue'
    import PaymentAuthorization from '../components/PaymentAuthorization.vue';
    import OfferSummary from '../components/OfferSummary.vue'
    import Moment from 'moment/moment'

    export default {
        components: { OfferSummary, PaymentAuthorization, Offers },

        props: {
            account: Object,
            customOffer: Object,
            billingProfile: Object,
            data: Object,
        },

        data() {
            return {
                section: 'offers',

                transactions: null,
                electronicConsentTemplate: null,
                electronicConsentDeclinedTemplate: null,
                paymentAuthorizationTransactions: null,
                paymentAuthorizationAgreementTemplate: null,

                pageForEvents: 'custom-offers-page',

                form: null,
            }
        },

        methods: {
            preview(form) {
                this.form = {...form};

                if (this.form.frequency === 'monthly' && this.paymentDateIsLastDayOfMonth(1)) {
                    this.form.frequency = 'end-of-month';
                }

                this.$http.post(
                    `${this.data.consumerPortalBaseUrl}/api/payments/preview`, this.form
                ).then(({ data }) => {
                    this.paymentAuthorizationAgreementTemplate = data.payment_authorization_agreement_template;
                    this.transactions = this.paymentAuthorizationTransactions = data.transactions;

                    this.section = 'payment-authorization';
                });
            },

            accept() {
                this.$http.post(
                    `${this.data.consumerPortalBaseUrl}/api/payments`, this.form
                ).then(({ data }) => {
                    this.electronicConsentTemplate = data.electronic_consent_template;
                    this.electronicConsentDeclinedTemplate = data.electronic_consent_declined_template;

                    this.section = 'summary';
                });
            },

            previewDeclined() {
                this.paymentAuthorizationTransactions = null;
                this.paymentAuthorizationAgreementTemplate = '';

                this.section = 'offers';
            },

            paymentDateIsLastDayOfMonth(dateIdx) {
                return Moment(this.form.payment_dates[dateIdx]).format('DD')
                    === Moment(this.form.payment_dates[dateIdx]).endOf('month').format('DD');
            },
        }
    }
</script>
